import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

function CustomDialog({ open, onClose, onConfirm, title, content, confirmText, cancelText }) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{cancelText || 'Cancel'}</Button>
        <Button onClick={onConfirm} color="primary">
          {confirmText || 'Confirm'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CustomDialog;